'use client'
import {
  DEAL_QUERY
} from "./chunk-SP6R2NC7.mjs";
import {
  getKvQuery
} from "./chunk-WEAY6VCH.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  LOCATION_QUERY
} from "./chunk-4R6INYD4.mjs";
import {
  PRODUCT_ACTION_QUERY
} from "./chunk-7KH2SW6P.mjs";
import {
  CMS_CARD_QUERY
} from "./chunk-AT6TTRZ3.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/product.ts
var getProductCardQuery = ({
  carouselLimit = 10,
  badgesLimit = 5
} = {}) => `
__typename
sys { id }
id
title
slug
organizationSlug
entityType { id slug title }
kv{${getKvQuery({ carouselLimit })}}
action{${PRODUCT_ACTION_QUERY}}
schedule{${SCHEDULE_QUERY}}
location{${LOCATION_QUERY}}
category { id title slug }
zone {
  title
  slug
  zoneLogo{${IMAGE_QUERY}}
  sponsorLogo{${IMAGE_QUERY}}
}
season { title slug }
auction { startAt endAt upfrontPayment }
deal{${DEAL_QUERY}}
badgesCollection(limit: ${badgesLimit}) {
  items {${CMS_CARD_QUERY}}
}
`;

export {
  getProductCardQuery
};
//# sourceMappingURL=chunk-QPUNJKQ3.mjs.map